import { Component, OnInit } from '@angular/core';
import { ArticleService } from 'src/app/services/article.service';
import { SupplierService } from 'src/app/services/supplier.service';
import { CustomerService } from 'src/app/services/customer.service';
import { Article } from 'src/app/models/article';
import { Supplier } from 'src/app/models/supplier';
import { Customer } from 'src/app/models/customer';
import { Unity } from 'src/app/models/unity';
import { UnityService } from 'src/app/services/unity.service';
import { UnityPipe } from 'src/app/pipes/unity.pipe';
import { environment } from 'src/environments/environment';
import { NgbDateAdapter, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/services/auth.service';
import { PurchaseOrderService } from 'src/app/services/purchase-order.service';

interface El {
  id:number,
  name:string
}

@Component({
  selector: 'app-purchase-order-report',
  templateUrl: './purchase-order-report.component.html',
  styleUrls: ['./purchase-order-report.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class PurchaseOrderReportComponent implements OnInit {
  type:{name:string, id:string} = null;
  types = [
    {name:'Articulo', id:'article'},
    {name:'Proveedor', id:'supplier'},
    {name:'Unidad', id:'unity'},
    {name:'Empresa', id:'customer'},
  ]
  loading:boolean = false;
  date1:Date = new Date();
  date2:Date = new Date();
  data = [];
  allTypes:boolean = false;
  total:number = 0;
  expand:boolean = false;

  elements:El[] = [];
  element:El = null;

  selectedEl:El[] = [];

  articles:Article[] = [];
  suppliers:Supplier[] = [];
  customers:Customer[] = [];
  unities:Unity[] = [];

  constructor( private articleServ:ArticleService, private supplierServ:SupplierService, private customerServ:CustomerService, private unityServ:UnityService, private unityPipe:UnityPipe, private authServ:AuthService, private purchaseServ:PurchaseOrderService ) {
    this.type = this.types[0];
  }

  ngOnInit() {
    this.calcElements();
  }

  search () {
    if (this.selectedEl.length || this.allTypes) {
      let ids = !this.allTypes ? this.selectedEl
        .map(el => el.id)
        .reduce((prev, curr) => prev + (prev == "" ? "" : ",") + curr, "") : null;
      this.loading = true;
      this.total = 0;
      this.purchaseServ.getReport(this.date1, this.date2, this.allTypes ? null : this.type.id, ids).then(arr => {
        this.data = arr;
        this.total = arr.map(d => ((d.quantity * d.unit_price) - ((d.quantity * d.unit_price) * (d.discount / 100 ))) * (d.iva*1 + 1)).reduce((an, ac) => ac + an, 0);
        this.loading = false;
      });
    }
  }

  getElements(elements, promise, callback) {
    if (!elements.length) {
      this.loading = true;
      promise.then(res => {
        callback(res);
        this.loading = false;
      });
    } else {
      callback(elements);
    }
  }

  calcElements() {
    this.element = null;
    this.clear();
    if (this.type.id == 'article') {
      this.getElements(this.articles, this.articleServ.getArticles(), (resp) => {
        this.articles = resp;
        this.elements = this.articles.map(article => {
          return {
            id: article.id,
            name: article.name,
          }
        })
      });
    } else if (this.type.id == 'supplier') {
      this.getElements(this.suppliers, this.supplierServ.getSuppliers(), (resp) => {
        this.suppliers = resp;
        this.elements = this.suppliers.map(supplier => {
          return {
            id: supplier.id,
            name: supplier.business_name,
          }
        })
      });
    } else if (this.type.id == 'unity') {
      this.getElements(this.unities, this.unityServ.getUnities(), (resp) => {
        this.unities = resp;
        this.elements = this.unities.map(unity => {
          return {
            id: unity.id,
            name: this.unityPipe.transform(unity),
          }
        })
      });
    } else if (this.type.id == 'customer') {
      this.getElements(this.customers, this.customerServ.getCustomers('Compañia'), (resp) => {
        this.customers = resp;
        this.elements = this.customers.map(customer => {
          return {
            id: customer.id,
            name: customer.name,
          }
        })
      });
    }
  }

  clear() {
    this.selectedEl = [];
  }

  download(type) {
    if (this.selectedEl.length || this.allTypes) {
      let user = this.authServ.getActualUser();
      let version = (this.authServ.is('purchases') || this.authServ.is('purchases_boss') || user.id == 5) ? '&version=2' : '';
      let ids = this.selectedEl
        .map(el => el.id)
        .reduce((prev, curr) => prev + (prev == "" ? "" : ",") + curr, "");
      window.open(environment.baseUrl + '/' + type + '/purchases/report' + (this.allTypes ? "" : "/" + this.type.id) + '?ids=' + ids + '&date1=' + this.date1.toString() + '&date2=' + this.date2.toString() + version, '_blank')
    }
  }
  
  add() {
    if (this.element) {
      if (!this.selectedEl.find(el => el.id == this.element.id)) {
        this.selectedEl.push(Object.assign({}, this.element));
      }
    }
  }

  remove(d:El) {
    this.selectedEl = this.selectedEl.filter(el => el.id != d.id);
  }

}
